import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JwtTokenService {
  private jwtTokenSubject = new BehaviorSubject<string>( '' );

  setJwtToken(token: string ) {
    this.jwtTokenSubject.next(token);
  }

  getJwtToken() {
    return this.jwtTokenSubject.value;
  }
}
